import IconInput from './IconInput';

export default IconInput;
